import React from 'react';

function TagManager() {
  return (
    <svg width="66" height="64" viewBox="0 0 66 64" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter colorInterpolationFilters="auto" id="filter-1">
          <feColorMatrix
            in="SourceGraphic"
            values="0 0 0 0 0.254902 0 0 0 0 0.329412 0 0 0 0 0.984314 0 0 0 1.000000 0"
          />
        </filter>
        <filter colorInterpolationFilters="auto" id="filter-2">
          <feColorMatrix
            in="SourceGraphic"
            values="0 0 0 0 0.764706 0 0 0 0 0.792157 0 0 0 0 0.839216 0 0 0 1.000000 0"
          />
        </filter>
        <filter colorInterpolationFilters="auto" id="filter-3">
          <feColorMatrix
            in="SourceGraphic"
            values="0 0 0 0 0.764706 0 0 0 0 0.792157 0 0 0 0 0.839216 0 0 0 1.000000 0"
          />
        </filter>
        <filter colorInterpolationFilters="auto" id="filter-4">
          <feColorMatrix
            in="SourceGraphic"
            values="0 0 0 0 0.764706 0 0 0 0 0.792157 0 0 0 0 0.839216 0 0 0 1.000000 0"
          />
        </filter>
      </defs>
      <g id="Tag-Management" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Devices_Manage-Tags_No-Tags" transform="translate(-725 -174)">
          <g id="Empty-state-tag-illustration" transform="translate(726 175)">
            <g id="Group-3" transform="translate(26 25)" fill="#C3CAD6">
              <path
                d="M3.625 0a.5.5 0 01.5.5v2.375H6.5a.5.5 0 01.5.5v.25a.5.5 0 01-.5.5H4.125V6.5a.5.5 0 01-.5.5h-.25a.5.5 0 01-.5-.5V4.125H.5a.5.5 0 01-.5-.5v-.25a.5.5 0 01.5-.5h2.375V.5a.5.5 0 01.5-.5h.25z"
                id="Combined-Shape"
              />
            </g>
            <path
              d="M46.5 30C53.956 30 60 36.044 60 43.5a13.46 13.46 0 01-4.058 9.649A13.456 13.456 0 0146.5 57C39.044 57 33 50.956 33 43.5S39.044 30 46.5 30zm0 1.5c-6.627 0-12 5.373-12 12s5.373 12 12 12c3.182 0 6.164-1.242 8.393-3.423A11.957 11.957 0 0058.5 43.5c0-6.627-5.373-12-12-12z"
              id="Combined-Shape-Copy"
              fill="#8008f7"
              fillRule="nonzero"
            />
            <g id="Group" transform="translate(28 26)">
              <g id="star-Icon" transform="translate(10 10)" filter="url(#filter-1)">
                <path
                  d="M12.718 2c.446 0 .607.046.77.134.163.087.291.215.378.378.088.163.134.324.134.77V7.38c0 .259-.01.348-.032.447a.87.87 0 01-.113.273c-.054.086-.11.156-.293.338l-5.656 5.656c-.315.315-.462.396-.639.45a.909.909 0 01-.534 0c-.177-.054-.324-.135-.64-.45L1.907 9.906c-.315-.315-.396-.462-.45-.639a.909.909 0 010-.534c.054-.177.135-.324.45-.64l5.656-5.655c.182-.182.252-.239.338-.293a.87.87 0 01.273-.113c.083-.019.158-.029.33-.031L12.719 2zM11 4a1 1 0 100 2 1 1 0 000-2z"
                  id="palette-Color-Fill"
                  fill="#0A1435"
                />
              </g>
            </g>
            <g id="star-Icon" transform="translate(3 3)" filter="url(#filter-2)">
              <path
                d="M9.75 2a.5.5 0 01.4.2l2.75 3.667a.5.5 0 01.1.3V13a1 1 0 01-1 1H4a1 1 0 01-1-1V3a1 1 0 011-1zM6.793 7H5.5a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h3a.5.5 0 00.5-.5V9.207a.5.5 0 00-.146-.353L7.146 7.146A.5.5 0 006.793 7z"
                id="palette-Color-Fill"
                fill="#0A1435"
              />
            </g>
            <g id="star-Icon" transform="translate(3 19)" filter="url(#filter-3)">
              <path
                d="M9.75 2a.5.5 0 01.4.2l2.75 3.667a.5.5 0 01.1.3V13a1 1 0 01-1 1H4a1 1 0 01-1-1V3a1 1 0 011-1zM6.793 7H5.5a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h3a.5.5 0 00.5-.5V9.207a.5.5 0 00-.146-.353L7.146 7.146A.5.5 0 006.793 7z"
                id="palette-Color-Fill"
                fill="#0A1435"
              />
            </g>
            <g id="star-Icon" transform="translate(19 3)" filter="url(#filter-4)">
              <path
                d="M9.75 2a.5.5 0 01.4.2l2.75 3.667a.5.5 0 01.1.3V13a1 1 0 01-1 1H4a1 1 0 01-1-1V3a1 1 0 011-1zM6.793 7H5.5a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h3a.5.5 0 00.5-.5V9.207a.5.5 0 00-.146-.353L7.146 7.146A.5.5 0 006.793 7z"
                id="palette-Color-Fill"
                fill="#0A1435"
              />
            </g>
            <path
              d="M23 35l-2.102 2.192a2 2 0 01-1.424.616L2.02 37.98a2 2 0 01-2.02-2V2a2 2 0 012-2h34a2 2 0 012 2v15.394a2 2 0 01-.336 1.11L36 21h0"
              id="Path-5"
              stroke="#C3CAD6"
              strokeWidth="1.35"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default TagManager;
